module.exports = __webpack_public_path__ + "static/media/blog-3.d7187400.jpg";